import React from 'react';
import { Card, Divider, Form } from 'antd';
import Text from 'antd/lib/typography/Text';
import { FormInstance } from 'antd/lib/form';
import moment from 'moment';

import FormInput from 'components/FormInput';
import Fieldset from 'components/Fieldset';
import Value from 'components/Value';
import { toCurrency } from 'utils/utils';

type TabClientInvoiceFeesProps = {
  form: FormInstance;
};

const TabClientInvoiceFees = (props: TabClientInvoiceFeesProps) => (
  <Card>
    <Fieldset comcode="reject">
      <Form.Item shouldUpdate noStyle>
        {({ getFieldValue }) => (
          <FormInput name="cirejecteddate" col xl={4} lg={4} md={12} sm={24}>
            <Text type="warning">
              {moment(getFieldValue('cirejecteddate')).format('YYYY-MM-DD')}
            </Text>
          </FormInput>
        )}
      </Form.Item>
      <FormInput name="cirejectfeesamount" col xl={8} lg={8} md={12} sm={24}>
        <Text type="warning">
          <Value formatter={toCurrency} />
        </Text>
      </FormInput>
      <FormInput
        name="cirejectedfeesinvoicedamount"
        col
        xl={8}
        lg={8}
        md={12}
        sm={24}
      >
        <Text type="warning">
          <Value formatter={toCurrency} />
        </Text>
      </FormInput>
    </Fieldset>

    <Divider />

    <Fieldset comcode="late-interest">
      <FormInput
        name="cilateinterestcalcilnbdayslatepaymentculatedamount"
        col
        md={12}
        sm={24}
      >
        <Text type="warning">
          days
          {/* {`${clientInvoice.cilnbdayslatepayment} days`}{' '} */}
        </Text>
      </FormInput>
      <FormInput name="cilateinterestcalculateddate" col lg={8} md={12} sm={24}>
        <Text type="warning">
          <Value formatter={(value) => moment(value).format('YYYY-MM-DD')} />
        </Text>
      </FormInput>
      <FormInput
        name="cilateinterestcalculatedamount"
        col
        md={12}
        sm={24}
      >
        <Text type="warning">
          <Value formatter={toCurrency} />
        </Text>
      </FormInput>
      <FormInput
        name="cilateinterestinvoicedamount"
        col
        xl={8}
        lg={8}
        md={12}
        sm={24}
      >
        <Text type="warning">
          <Value formatter={toCurrency} />
        </Text>
      </FormInput>
    </Fieldset>
  </Card>
);

export default TabClientInvoiceFees;
